module.exports = __webpack_public_path__ + "img/pic__photo_03@2x.38a93fb5.png";